import styled from '@emotion/styled'
import { colors } from '../../../styles/theme'

const S = {}

S.Logo = styled.div`
  width: 100%;
  a {
    transition: none;
    display: inline-block;
  
    &:focus {
      outline: 0.25rem solid rgba(160, 160, 160, 0.75);
      outline-offset: 0.25rem;
      box-shadow: none;
      text-decoration: underline;
      .cr-logo-svg { 
        fill: ${colors.orange};
      }
    }
  }

  .cr-logo-svg {
    width: 13.5rem;
    height: auto;
  }
`

export default S
